import { useCallback } from "react";
import { useUserState } from "./useUserState";

/** Width of one warning light in pixels: the range of the slider and the step between sizes. */
export const TELL_TALE_SIZE = { min: 32, max: 96, step: 4 } as const;

export const DEFAULT_TELL_TALE_SIZE = 56;

const DEFAULTS = { px: DEFAULT_TELL_TALE_SIZE as number };

/** How wide the checklist draws each warning light, remembered per user. */
export function useTellTaleSize() {
  const { value, setValue } = useUserState("checklist:tellTaleSize", DEFAULTS);

  const stored = Number(value.px);
  const px = Number.isFinite(stored)
    ? Math.min(TELL_TALE_SIZE.max, Math.max(TELL_TALE_SIZE.min, stored))
    : DEFAULT_TELL_TALE_SIZE;
  const setPx = useCallback((next: number) => setValue({ px: next }), [setValue]);

  return { px, setPx };
}
